import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IMerchantFormMeta {
  // Merchant Data
  merchantId: FormInputMeta;
  status: FormInputMeta;
  doingBusinessAs: FormInputMeta;
  solvabilityLevel: FormInputMeta;
  merchantType: FormInputMeta;
  mccGroup: FormInputMeta;
  merchantProfessionalGroup: FormInputMeta;
  transactionCategoryCode: FormInputMeta;
  cardAcceptorName: FormInputMeta;
  paymentChannel: FormInputMeta;
  merchantDomain: FormInputMeta;
  acquirerBank: FormInputMeta;
  acquiringInstitution: FormInputMeta;
  terminalId: FormInputMeta;
  terminalStatus: FormInputMeta;  
  

  schema: any;
}

const MerchantFormMeta = {} as IMerchantFormMeta;

// Merchant Data
MerchantFormMeta.merchantId = {
  name: 'merchantId',
  type: 'text',
  label: 'Id du commerçant',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Statut',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.doingBusinessAs = {
  name: 'doingBusinessAs',
  type: 'text',
  label: 'Faire des affaires en tant que',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.solvabilityLevel = {
  name: 'solvabilityLevel',
  type: 'text',
  label: 'Niveau de solvabilité',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.merchantType = {
  name: 'merchantType',
  type: 'text',
  label: 'Type de commerçant',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.mccGroup = {
  name: 'mccGroup',
  type: 'text',
  label: 'Groupe MCC',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.merchantProfessionalGroup = {
  name: 'merchantProfessionalGroup',
  type: 'text',
  label: 'Groupe professionnel du commerçant',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.transactionCategoryCode = {
  name: 'transactionCategoryCode',
  type: 'text',
  label: 'Code de catégorie de la transaction',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.cardAcceptorName = {
  name: 'cardAcceptorName',
  type: 'text',
  label: 'Nom de l\'accepteur de cartes',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.paymentChannel = {
  name: 'paymentChannel',
  type: 'text',
  label: 'canal de paiement',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.merchantDomain = {
  name: 'merchantDomain',
  type: 'text',
  label: 'Domaine du commerçant',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
},
MerchantFormMeta.acquirerBank = {
  name: 'acquirerBank',
  type: 'text',
  label: 'Banque acquéreur',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.acquiringInstitution = {
  name: 'acquiringInstitution',
  type: 'text',
  label: 'Etablissement acquéreur',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.terminalId = {
  name: 'terminalId',
  type: 'text',
  label: 'Id du terminal',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}
MerchantFormMeta.terminalStatus = {
  name: 'terminalStatus',
  type: 'text',
  label: 'Statut du terminal',
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
}


MerchantFormMeta.schema = yup.object().shape(getValidationSchema(MerchantFormMeta));

export default MerchantFormMeta;